import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemInformation: {},
  isLoading: false,
//   showDialog: false,
};

//STORE SLICE
export const itemInformationListSlice = createSlice({
  name: "itemInformationListSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showItemInformationDialog(state, action) {
    return {
        ...state,
        // showDialog: true,
        itemInformation: action.payload,
      };
    },
    closeItemInformationDialog(state) {
      return {
        ...state,
        // showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    }, 
  },
});

//ACTIONS
export const {
  showItemInformationDialog,
  closeItemInformationDialog,
  showLoading,
  hideLoading,
} = itemInformationListSlice.actions;

export default itemInformationListSlice.reducer;
